<template>
  <div :class="['editor-detail-skeleton', { _mobile: isMobile }]">
    <div class="editor-detail-skeleton__content">
      <div class="editor-detail-skeleton__breadcrumbs">
        <BreadcrumbsSkeleton />
      </div>
      <CardSkeleton />
      <AboutSkeleton />
      <ExperienceSkeleton />
      <PublicationsSkeleton />
      <ArticlesSkeleton />
    </div>
  </div>
</template>

<script setup lang="ts">
import BreadcrumbsSkeleton from './BreadcrumbsSkeleton.vue';
import CardSkeleton from './CardSkeleton.vue';
import AboutSkeleton from './AboutSkeleton.vue';
import ExperienceSkeleton from './ExperienceSkeleton.vue';
import PublicationsSkeleton from './PublicationsSkeleton.vue';
import ArticlesSkeleton from './ArticlesSkeleton.vue';

const isMobile: boolean = useIsMobile();
</script>

<style lang="less">
.editor-detail-skeleton {
  &__content {
    .flex-column(@size-x10);

    max-width: 880px;
  }

  &__breadcrumbs {
    margin-top: @size-x10;
  }
}
</style>
